export default {
    computed: {
        searchParam() {
            return window?.location?.search;
        },
    },

    methods: {
        // Public use
        stopEvent(event) {
            event.stopPropagation();
            event.preventDefault();
            event.cancelBubble = true;
            event.returnValue = false;
        },

        // Public use
        stopBubble(event) {
            event.stopPropagation();
            event.cancelBubble = true;
        },

        // Public use
        // Work in local time zone within the browser, so use Date.getXXX()
        toLocalIsoDateString(date) {
            return date.getFullYear().toString().padStart(4, '0') + '-' +
                (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
                date.getDate().toString().padStart(2, '0');
        },

        // Public use
        // Work in local time zone within the browser, so use new Date(yyyy, mm, dd)
        parseLocalIsoDateString(string) {
            var parts = string.split('-');
            var yyyy = Number.parseInt(parts[0]);
            var mm = Number.parseInt(parts[1]);
            var dd = Number.parseInt(parts[2]);
            if (!Number.isNaN(yyyy) && !Number.isNaN(mm) && !Number.isNaN(dd)) {
                return new Date(yyyy, mm - 1, dd);
            } else {
                return new Date(Number.NaN);
            }
        },

        // Public use
        getValueByPath(obj, path) {
            path = path.split('.');
            path = path.flatMap(i => i.split('['));

            path = path.map(i => {
                if (i.endsWith(']')) {
                    i = i.slice(0, i.length - 1);
                    var value = Number.parseInt(i);
                    if (Number.isInteger(value)) return value;
                    else return i;
                } else return i;
            });

            path = path.map(i => {
                if (i.length > 2 && i.startsWith('"') && i.endsWith('"')) {
                    i = i.slice(1, i.length - 1);
                    return i;
                } else if (i.length > 2 && i.startsWith('\'') && i.endsWith('\'')) {
                    i = i.slice(1, i.length - 1);
                    return i;
                } else return i;
            });

            return path.reduce((source, key) => source == null ? null : source == undefined ? undefined : source[key], obj);
        },

        parseProp(propName, type, dataName, ignoreNullValue) {
            if (this[propName] == null) {
                if (this[dataName] != null) {
                    if (!ignoreNullValue) this[dataName] = null;
                }
            } else {
                if (type == Number) {
                    let number = Number.parseFloat(this[propName]);
                    if (!Number.isNaN(number) && this[dataName] != number) this[dataName] = number;
                } else if (type == Date) {
                    let date = new Date(this[propName]);
                    if (!isNaN(date) && (this[dataName] == null || this[dataName].getTime() != date.getTime())) this[dataName] = date;
                } else if (type == String) {
                    let string = this[propName]?.toString();
                    if (this[dataName] != string) this[dataName] = string;
                } else if (type == Array) {
                    let array = this[propName];
                    if (Array.isArray(array) && this[dataName] != array) this[dataName] = array;
                } else if (type == Object) {
                    let obj = this[propName];
                    if (this[dataName] != obj) this[dataName] = obj;
                }
            }
        },

        emitProp(propName, dataName) {
            if (this[propName] !== this[dataName]) {
                if (propName == 'value') this.$emit('input', this[dataName]);
                else this.$emit('update:' + propName, this[dataName]);
            }
        },

        // Public use
        syncProps() {
            for (let dataName in this.$data) {
                if (dataName.endsWith('Number')) {
                    // Sync between my prop and my data, using Number as type
                    let propName = dataName.substring(0, dataName.length - 6);
                    if (propName in this.$props) this.syncProp(propName, Number, dataName);
                } else if (dataName.endsWith('Date')) {
                    // Sync between my prop and my data, using Date as type
                    let propName = dataName.substring(0, dataName.length - 4);
                    if (propName in this.$props) this.syncProp(propName, Date, dataName);
                } else if (dataName.endsWith('String')) {
                    // Sync between my prop and my data, using String as type
                    let propName = dataName.substring(0, dataName.length - 6);
                    if (propName in this.$props) this.syncProp(propName, String, dataName);
                } else if (dataName.endsWith('Array')) {
                    // Sync between my prop and my data, using Array as type
                    let propName = dataName.substring(0, dataName.length - 5);
                    if (propName in this.$props) this.syncProp(propName, Array, dataName);
                } else if (dataName.endsWith('Object')) {
                    // Sync between my prop and my data, using Object as type
                    let propName = dataName.substring(0, dataName.length - 6);
                    if (propName in this.$props) this.syncProp(propName, Object, dataName);
                }
            }
        },

        // Public use
        syncProp(propName, type, dataName) {
            if (!dataName) {
                if (type == Number) dataName = propName + 'Number';
                else if (type == Date) dataName = propName + 'Date';
                else if (type == String) dataName = propName + 'String';
                else if (type == Array) dataName = propName + 'Array';
                else if (type == Object) dataName = propName + 'Object';
            }

            this.parseProp(propName, type, dataName, true); // Ignore initial value of null prop and keep default value in data
            this.emitProp(propName, dataName);
            this.$watch(propName, () => this.parseProp(propName, type, dataName, false));
            this.$watch(dataName, () => this.emitProp(propName, dataName));
        },

        parseSearchParam(searchParamName, type, dataName, ignoreNullValue, defaultValue) {
            var params = new URLSearchParams(window.location.search);

            if (!params.has(searchParamName)) {
                //if (this[dataName] != null) {
                //    if (!ignoreNullValue) this[dataName] = null;
                //}
                if (type == Date) {
                    if (!(this[dataName] instanceof Date) || !(defaultValue instanceof Date) || this[dataName].getTime() != defaultValue.getTime()) this[dataName] = defaultValue;
                } else {
                    if (this[dataName] != defaultValue) this[dataName] = defaultValue;
                }
            } else {
                if (type == Number) {
                    let number = Number.parseFloat(params.get(searchParamName));
                    if (!Number.isNaN(number) && this[dataName] != number) this[dataName] = number;
                } else if (type == Date) {
                    // Date only, datetime is not supported
                    // Work in local time zone within the browser, so use new Date(yyyy, mm, dd)
                    var date = this.parseLocalIsoDateString(params.get(searchParamName));
                    if (!isNaN(date) && (this[dataName] == null || this[dataName].getTime() != date.getTime())) this[dataName] = date;
                } else if (type == String) {
                    let string = params.get(searchParamName);
                    if (this[dataName] != string) this[dataName] = string;
                } else if (type == Object) {
                    // Object is not supported now, maybe base64(json()) later
                } else {
                    // Not supported
                }
            }
        },

        writeSearchParam(searchParamName, type, dataName) {
            var params = new URLSearchParams(window.location.search);
            var currentFullPath = params.toString()

            if (this[dataName] == null) {
                params.delete(searchParamName);
            } else {
                if (type == Number) {
                    params.set(searchParamName, this[dataName].toString());
                } else if (type == Date) {
                    // Date only, datetime is not supported
                    // Work in local time zone within the browser, so use Date.getXXX()
                    params.set(
                        searchParamName,
                        this.toLocalIsoDateString(this[dataName]),
                    );
                } else if (type == String) {
                    if (this[dataName]) {
                        params.set(searchParamName, this[dataName].toString());
                    } else {
                        params.delete(searchParamName);
                    }
                } else if (type == Object) {
                    // Object is not supported now, maybe base64(json()) later
                } else {
                    // Not supported
                }
            }

            var fullPath = params.toString();
            if (fullPath != currentFullPath) {
                if (fullPath) {
                    fullPath = this.$route.path + '?' + fullPath;
                } else {
                    fullPath = this.$route.path;
                }
                fullPath = fullPath + this.$route.hash;

                if (this.$route.fullPath != fullPath) this.$router.replace(fullPath);
            }
        },

        // Public use
        syncSearchParam(searchParamName, type, dataName) {
            if (!dataName) dataName = searchParamName;
            let defaultValue = this[dataName];
            let writingNull = false;
            this.parseSearchParam(searchParamName, type, dataName, true, defaultValue); // Ignore initial value of null prop and keep default value in data
            this.writeSearchParam(searchParamName, type, dataName);
            this.$watch(`$route.query.${searchParamName}`, (newValue) => {
                if (writingNull && (newValue == null || newValue == undefined)) {
                    writingNull = false;
                } else {
                    this.parseSearchParam(searchParamName, type, dataName, false, defaultValue);
                }
            });
            this.$watch(dataName, (newValue) => {
                if (newValue == null || newValue == undefined) writingNull = true;
                this.writeSearchParam(searchParamName, type, dataName);
            });
        },

        // Public use
        setupRouterLink(element) {
            // Change the behaviour of <a> inside the specified element to <router-link>
            if (element && typeof element.getElementsByTagName == 'function') {
                var anchors = element.getElementsByTagName('a');
                for (var anchor of anchors) {
                    var href = anchor.getAttribute('href');

                    if (!href.includes('://')) {
                        // Process relative URLs only
                        anchor.addEventListener('click', (event) => {
                            this.$router.push(event.target.getAttribute('href'));
                            event.preventDefault();
                        });
                    }
                }
            }
        },
    },
}